var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeDoll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.73438V16.2656",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2969 10.3594C14.2969 10.1439 14.2544 9.93058 14.172 9.73154C14.0895 9.53249 13.9687 9.35162 13.8163 9.19928C13.664 9.04693 13.4831 8.92608 13.2841 8.84364C13.085 8.76119 12.8717 8.71875 12.6562 8.71875H11.1797C10.7446 8.71875 10.3273 8.8916 10.0196 9.19928C9.71191 9.50695 9.53906 9.92425 9.53906 10.3594C9.53906 10.7945 9.71191 11.2118 10.0196 11.5195C10.3273 11.8271 10.7446 12 11.1797 12H12.9844C13.4195 12 13.8368 12.1729 14.1445 12.4805C14.4521 12.7882 14.625 13.2055 14.625 13.6406C14.625 14.0757 14.4521 14.493 14.1445 14.8007C13.8368 15.1084 13.4195 15.2812 12.9844 15.2812H11.0156C10.5805 15.2812 10.1632 15.1084 9.85553 14.8007C9.54785 14.493 9.375 14.0757 9.375 13.6406",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDoll);
export default __webpack_public_path__ + "static/media/eye_doll.461588bc427eafec0da7e0b3ca74643b.svg";
export { ForwardRef as ReactComponent };